import { useState } from "react";

import { type DealFinancialReturnsResponse } from "@vega-api/generated/types/dealFinancialReturnsResponse";
import { m } from "@vega-core/paraglide/messages";
import {
  FinancialReturnsTrendChart,
  TimeRange,
} from "@vega-modules/scenes/CoInvestmentsGP/pages/components/FinancialReturnsTrendChart";
import { ReportSectionMessage } from "@vega-modules/scenes/CoInvestmentsGP/pages/components/ReportSectionMessage";
import { MetricKey } from "@vega-modules/scenes/CoInvestmentsGP/utils/formatFinancialReturns";

export function MoicTrendSection({
  data,
  isError,
  isLoading,
  onRetry,
}: {
  data: DealFinancialReturnsResponse | undefined;
  isError: boolean;
  isLoading: boolean;
  onRetry: () => void;
}) {
  const [timeRange, setTimeRange] = useState<TimeRange>(TimeRange.All);

  if (isError) {
    return (
      <ReportSectionMessage
        dataTestId="lp-moic-trend-error"
        message={m.common_error_somethingWentWrong()}
        onRetry={onRetry}
      />
    );
  }

  return (
    <FinancialReturnsTrendChart
      activeMetric={MetricKey.Moic}
      dataTestId="lp-moic-trend"
      isLoading={isLoading}
      onTimeRangeChange={setTimeRange}
      points={data?.moicTrend ?? []}
      timeRange={timeRange}
    />
  );
}
